/**
 * Single source of truth for services data — used by both the Services page
 * (all 7) and the Home page teaser (a curated subset). Keeps content and
 * translations in one place instead of two catalogs drifting apart.
 */
import serviceImages from "./serviceImages";

const I18N_KEY_BY_SERVICE = {
  webDev: "webDevelopment",
  mobileApps: "mobileApps",
  cloudSolutions: "cloudSolutions",
  uiuxDesign: "uiux",
  seoOptimization: "seo",
  consulting: "consulting",
  digitalProfile: "digitalProfile",
};

const IMAGE_BY_SERVICE = {
  webDev: serviceImages.wde,
  mobileApps: serviceImages.mobile,
  cloudSolutions: serviceImages.cloud,
  uiuxDesign: serviceImages.uiux,
  seoOptimization: serviceImages.seo,
  consulting: serviceImages.consulting,
  digitalProfile: serviceImages.digitalProfile,
};

export const ALL_SERVICE_KEYS = [
  "webDev",
  "mobileApps",
  "cloudSolutions",
  "uiuxDesign",
  "seoOptimization",
  "consulting",
  "digitalProfile",
];

export const buildService = (t, key) => {
  const i18nKey = I18N_KEY_BY_SERVICE[key];
  return {
    key,
    title: t(`services.${i18nKey}.title`),
    description: t(`services.${i18nKey}.description`),
    image: IMAGE_BY_SERVICE[key],
    modalContent: {
      details: t(`services.${i18nKey}.details`),
      features: t(`services.${i18nKey}.features`, { returnObjects: true }),
    },
  };
};

export const getAllServices = (t) => ALL_SERVICE_KEYS.map((key) => buildService(t, key));
